{
  "resourceGroupsAdmin": {
    "title": "Resource groups",
    "resourceTypes": "Resource types",
    "groups": "Groups",
    "addGroup": "Add group",
    "cancel": "Cancel",
    "disabledTooltip": "Groups are disabled in Fields for {{name}}. Click to enable them.",
    "disabledReadOnlyTooltip": "Groups are disabled in Fields for {{name}}. Ask an administrator to enable them for an active resource type.",
    "disabledDescription": "Groups are disabled in Fields for {{name}}. Enable the Groups field to manage groups for this resource type.",
    "enableGroups": "Enable groups",
    "enableTitle": "Enable groups for {{name}}?",
    "enableDescription": "This will activate the Groups field in Fields for {{name}} at the global resource-type level. Existing groups will be preserved; other fields and workspace-specific settings will not be changed.",
    "enabling": "Enabling…",
    "enableFailed": "Could not enable groups. Please try again.",
    "description": "Edit names and colours, remove groups, or drag rows to change their order.",
    "archivedDescription": "View archived groups for this resource type. Restore a group to make it available again.",
    "restore": "Restore group",
    "restoreTitle": "Restore group “{{name}}”?",
    "restoreDescription": "This group will become active again for its resource type. Its name, colour and existing resource assignments will be preserved.",
    "restoreLabel": "Restore {{name}}",
    "emptyArchivedGroups": "No archived groups",
    "emptyArchivedGroupsDescription": "This resource type has no archived groups.",
    "colour": "Colour",
    "nameLabel": "Name for {{name}}",
    "colourLabel": "Colour for {{name}}",
    "saved": "Groups updated",
    "saveFailed": "Could not save your changes. Please try again.",
    "nameRequired": "Enter a name for the group.",
    "entityName": "group",
    "emptyGroups": "No groups",
    "emptyGroupsDescription": "This resource type has no active groups.",
    "emptyTypes": "No resource types",
    "emptyTypesDescription": "Create a resource type before managing its groups.",
    "loadFailed": "Could not load groups.",
    "typesFailed": "Could not load resource types."
  },
  "core_fields": {
    "first_name": "First Name",
    "last_name": "Last Name",
    "nick_name": "Nickname",
    "full_name": "Full Name",
    "role": "Role",
    "import_id": "Import ID",
    "contact_type": "Contact Type",
    "resource_type_id": "Resource Type",
    "represented_by_id": "Represented By",
    "profile_picture": "Profile Picture",
    "rates": "Rates",
    "tags": "Tags",
    "groups": "Groups",
    "locations": "Locations",
    "emails": "Emails",
    "websites": "Websites",
    "phone_numbers": "Phone Numbers",
    "socials": "Socials",
    "pronouns": "Pronouns",
    "code": "Code",
    "icon": "Icon",
    "title": "Title",
    "production_type_id": "Production Type",
    "production_template_id": "Production Template",
    "production_date": "Production Date",
    "shotflow_instance": "Shotflow Instance",
    "status_id": "Status",
    "description": "Description",
    "color": "Color",
    "timezone": "Timezone",
    "events": "Schedule",
    "production_locations": "Locations",
    "budget_amount": "Budget Amount",
    "estimated_total": "Estimated Total",
    "actual_total": "Actual Total",
    "budget_expenses": "Budget Expenses",
    "budget_expenses.name": "Name",
    "budget_expenses.description": "Description",
    "budget_expenses.estimate": "Estimate",
    "budget_expenses.archived": "Archived",
    "budget_expenses.group_id": "Group",
    "budget_expenses.slot_category_id": "Category",
    "budget_expenses.expenses": "Expenses",
    "budget_expenses.expenses.booking_id": "Booking",
    "budget_expenses.expenses.booking.resource_id": "Resource",
    "budget_expenses.expenses.commit_vendor": "Vendor",
    "budget_expenses.expenses.commit": "Committed",
    "budget_expenses.expenses.created_at": "Created At",
    "budget_expenses.expenses.updated_at": "Updated At",
    "budget_expenses.expenses.slot_category_id": "Category",
    "budget_expenses.expenses.receipts": "Receipts",
    "resourcing_at": "Resourcing At",
    "ready_at": "Ready At",
    "completed_at": "Completed At",
    "cancelled_at": "Cancelled At",
    "booking_type_id": "Booking Type",
    "rate": "Rate",
    "note": "Note",
    "contracts": "Contracts",
    "invoices": "Invoices",
    "submitted_date": "Submitted Date",
    "agreed_date": "Agreed Date",
    "pencilled_at": "Pencilled At",
    "confirmed_at": "Confirmed At",
    "createdAt": "Created At",
    "updatedAt": "Updated At",
    "archived": "Archived",
    "user_id": "Owner",
    "bookings": "Bookings",
    "public_id": "Public ID",
    "status": "Status",
    "public_title": "Public Title",
    "public_description": "Public Description",
    "confirmation_text": "Confirmation Text",
    "enable_notifications": "Enable Notifications",
    "published": "Published",
    "deadline": "Deadline",
    "public": "Public",
    "expanded": "Expanded",
    "public_feedback": "Public Feedback",
    "layout": "Layout",
    "enable_voting": "Enable Voting",
    "enable_commenting": "Enable Commenting",
    "billing": "Billing",
    "social": "Social",
    "hard_drive": "Hard Drive",
    "from_date": "From Date",
    "to_date": "To Date",
    "call_time": "Call Time",
    "resource_slots": "Resource Slots",
    "resource": "Resource",
    "resource_slot_assignments": "Resource Slots",
    "organisation": "Organisation",
    "organisation_id": "Organisation",
    "availability": "Availability",
    "all": "All",
    "published_at": "Published At",
    "callsheet_date": "Callsheet Date"
  },
  "rate_intervals": {
    "DAILY": "Daily",
    "HOURLY": "Hourly",
    "FIXED": "Fixed",
    "ITEM": "Per Item"
  },
  "rateInput": {
    "currencyAria": "Currency",
    "amountAria": "Rate amount",
    "intervalAria": "Billing unit",
    "quantityAria": "Quantity",
    "currencyTooltip": "Currency used for this rate.",
    "amountTooltip": "Rate amount (before quantity and fees).",
    "intervalTooltip": "How this rate is billed, e.g. per hour or per day.",
    "multiplyTooltip": "Rate is multiplied by quantity for the line total.",
    "quantityTooltip": "How many units this rate applies to."
  },
  "rateEditor": {
    "name": "Name",
    "namePlaceholder": "e.g. Day rate",
    "amount": "Amount",
    "amountPlaceholder": "0.00",
    "currency": "Currency",
    "billingUnit": "Billing unit",
    "fees": "Fees on top",
    "feesHint": "% of amount",
    "note": "Note",
    "optional": "optional",
    "notePlaceholder": "Terms, inclusions, conditions",
    "noAmount": "No amount",
    "unnamed": "Unnamed rate",
    "fee": {
      "agency": "Agency",
      "payroll": "Payroll",
      "processing": "Processing"
    },
    "feeFull": {
      "agency": "Agency fee",
      "payroll": "Payroll fee",
      "processing": "Processing fee"
    },
    "feeSummary": "+{{percent}}% {{fee}}",
    "feeSpoken": "{{percent}}% {{fee}}",
    "plusFees": "plus {{fees}}",
    "unit": {
      "DAILY": "/ day",
      "HOURLY": "/ hour",
      "FIXED": "fixed",
      "ITEM": "/ item"
    },
    "unitSpoken": {
      "DAILY": "per day",
      "HOURLY": "per hour",
      "FIXED": "fixed fee",
      "ITEM": "per item"
    },
    "unitOption": {
      "DAILY": "Per day",
      "HOURLY": "Per hour",
      "FIXED": "Fixed fee",
      "ITEM": "Per item"
    },
    "autoName": {
      "DAILY": "Day rate",
      "HOURLY": "Hourly rate",
      "FIXED": "Fixed fee",
      "ITEM": "Item rate"
    },
    "withFees": "With fees",
    "howCalculated": "Breakdown",
    "breakdown": {
      "rate": "Rate",
      "agency": "Agency {{percent}}% of the rate",
      "payroll": "Payroll {{percent}}% of {{base}} (rate minus agency)",
      "processing": "Processing {{percent}}% of {{base}} (subtotal)",
      "total": "With fees"
    },
    "rateCard": "Rate card",
    "rateCardHint": "Managed in Settings › Rate cards. Changes to the card apply here.",
    "detachAndEdit": "Detach and edit",
    "manageRateCards": "Manage rate cards",
    "rateCardUnavailable": "Unavailable",
    "rateCardUnavailableHint": "This rate card was archived or you can’t view it. Remove it or replace it with a current card.",
    "rateCardFallbackName": "Rate card #{{id}}",
    "errors": {
      "nameRequired": "Enter a name, like Day rate.",
      "amountRequired": "Enter an amount.",
      "currencyRequired": "Pick a currency.",
      "amountInvalid": "Enter a number, like 850 or 850.50.",
      "amountNegative": "Enter an amount of 0 or more.",
      "amountDecimals": "Use no more than {{digits}} decimal places.",
      "amountNoDecimals": "{{currency}} amounts can’t have decimals.",
      "feeRange": "{{fee}}: enter a whole number from 0 to 100.",
      "unitUnsupported": "Pick per day, per hour or fixed fee.",
      "amountTooLarge": "Enter an amount up to {{max}}."
    }
  },
  "validation": {
    "required": "This field is required",
    "url": "Not a valid link",
    "email": "Not a valid email address",
    "phone_number": "Not a valid phone number"
  },
  "standard-date-filter": {
    "timestamp": {
      "last7Days": "Last 7 days",
      "last30Days": "Last 30 days",
      "last90Days": "Last 90 days"
    },
    "scheduled": {
      "today": "Today",
      "tomorrow": "Tomorrow",
      "nextWeek": "Next week",
      "nextMonth": "Next month"
    },
    "custom": {
      "last7Days": "Last 7 days",
      "last30Days": "Last 30 days",
      "last90Days": "Last 90 days",
      "today": "Today",
      "tomorrow": "Tomorrow",
      "nextWeek": "Next week",
      "nextMonth": "Next month"
    }
  },
  "AccountSettingsPronouns": {
    "sectionLabel": "Resources",
    "title": "Pronouns options",
    "description": "Define which pronoun labels appear when editing people (Individual, Talent, Agent).",
    "listTitle": "Allowed pronouns",
    "help": "These values are validated when saving a resource. Drag the handle to reorder; duplicate entries are removed on save.",
    "dragHandleLabel": "Drag to reorder",
    "optionPlaceholder": "e.g. They/Them",
    "addOption": "Add option",
    "remove": "Remove",
    "save": "Save",
    "saved": "Pronouns options saved",
    "saveFailed": "Could not save pronouns options"
  },
  "online_status": {
    "online": "You're online",
    "offline": "You're offline",
    "toast_offline": "You're offline",
    "toast_online": "You're back online"
  },
  "enterprise": {
    "globalScopeLabel": "Global",
    "tags": "Tags",
    "rateCards": "Rate cards",
    "expenseTypes": "Expense types",
    "slotCategories": "Slot categories",
    "loadingWorkspaces": "Loading workspaces…",
    "workspacesUnavailable": "Workspaces unavailable",
    "emptyWorkspaces": "No workspaces available",
    "emptyWorkspacesHint": "This should not happen. Contact support if you see this.",
    "teamsSectionLabel": "Teams",
    "loadingTeams": "Loading teams…",
    "teamsUnavailable": "Teams unavailable",
    "emptyTeams": "No teams in this workspace",
    "emptyTeamsHint": "This should not happen. Contact support if you see this.",
    "teamsSettingsLabel": "Team settings",
    "newTeam": "New team",
    "newWorkspace": "New workspace",
    "switchWorkspace": "Switch workspace",
    "createWorkspace": "Create workspace",
    "createWorkspaceDescription": "Add a new enterprise workspace to your organization.",
    "editWorkspace": "Edit workspace",
    "editWorkspaceDescription": "Update workspace name and icon.",
    "createTeam": "Create team",
    "createTeamDescription": "Add a new team under this workspace.",
    "editTeam": "Edit team",
    "editTeamDescription": "Update team name, icon, and color.",
    "archive": "Archive",
    "unarchive": "Restore",
    "activeTab": "Active",
    "archivedTab": "Archived",
    "emptyArchivedWorkspaces": "No archived workspaces",
    "emptyArchivedTeams": "No archived teams in this workspace",
    "edit": "Edit",
    "create": "Create",
    "save": "Save",
    "fieldName": "Name",
    "fieldIcon": "Icon",
    "fieldIconColor": "Icon color",
    "pickIconColor": "Pick a color",
    "manageEntity": "Manage",
    "manageEnterprise": "Manage enterprise",
    "visitorManagement": "Visitor management",
    "organizationTalents": "Organization talents",
    "manageEnterpriseDescription": "Create, edit, and archive workspaces and teams in your organization.",
    "workspacesTitle": "Workspaces",
    "teamsTitle": "Teams",
    "teamsForWorkspace": "Teams in {{workspace}}",
    "selectWorkspaceHint": "Select a workspace to manage its teams",
    "teamDashboard": "Dashboard"
  },
  "bookingConfirmationSettings": {
    "title": "Booking confirmation template",
    "description": "Configure the booking confirmation email template for this workspace.",
    "templatePlaceholder": "Write the confirmation email body…",
    "insertPlaceholder": "Insert block",
    "insertPlaceholderMenuLabel": "Fields",
    "insertPlaceholderSectionsLabel": "Blocks",
    "hints": {
      "first_name": "Resource’s first name",
      "full_name": "Resource’s full name",
      "booking_status": "Current booking status",
      "booking_role": "Role on this booking",
      "production_title": "Production title",
      "booking_estimated_total": "Estimated total for the booking",
      "booking_note": "Note on the booking",
      "section": {
        "booking_events": "Repeats for each booking date or time",
        "booking_estimated_total": "Only included when a total is set",
        "booking_note": "Only included when a note is set"
      }
    },
    "frameTitle": "Template editor",
    "previewLabel": "Preview",
    "viewModeEditor": "Code",
    "viewModePreview": "Preview",
    "viewModeSplit": "Split",
    "emptyTip": "Sending a booking confirmation requires a non-empty template.",
    "save": "Save",
    "cancel": "Cancel",
    "saveSuccess": "Booking confirmation template updated",
    "saveFailed": "Failed to update the booking confirmation template",
    "loadFailed": "Couldn't load the booking confirmation template",
    "missingWorkspace": "Open this page from a workspace to edit its confirmation template."
  },
  "workspaceGeneralSettings": {
    "title": "General",
    "description": "Manage general settings about this workspace",
    "missingWorkspace": "Open this page from a workspace to edit its general settings.",
    "brandImage": {
      "title": "Brand image",
      "description": "Not used in the app yet.",
      "fieldLabel": "Brand image"
    },
    "defaultCurrency": {
      "title": "Default currency",
      "description": "Used when a new production, rate, or expense does not specify a currency.",
      "fieldLabel": "Currency"
    },
    "defaultLocale": {
      "title": "Language",
      "description": "Language used across public facing features and emails sent from this workspace.",
      "fieldLabel": "Language"
    },
    "defaultCountryCode": {
      "title": "Localisation",
      "description": "Default country code when entering national phone numbers.",
      "fieldLabel": "Country"
    },
    "saveSuccess": "Settings updated",
    "saveFailed": "Failed to update settings",
    "loadFailed": "Couldn't load settings",
    "defaultTimezone": {
      "title": "Timezone",
      "description": "Default timezone for schedules, events and callsheets in this workspace.",
      "fieldLabel": "Timezone"
    },
    "roleMissingDays": {
      "title": "Production alerts",
      "description": "Open or resourcing productions that start within this many days are marked as at risk.",
      "fieldLabel": "Alert before the shoot",
      "unit": "days"
    },
    "tagsFixed": {
      "title": "Tags",
      "description": "Tags are shared by every workspace. With fixed tags on, people in this workspace pick from existing tags and cannot create new ones while editing a resource. New tags are added in the global tag settings.",
      "fieldLabel": "Fixed tags"
    }
  },
  "publicProfileSettings": {
    "title": "Public profile",
    "description": "Set the look and feel of published pages to your brand.",
    "sections": {
      "brandImage": "Brand image",
      "names": "Names",
      "brandColors": "Brand colors"
    },
    "fields": {
      "organizationName": "Organization name",
      "organizationNamePlaceholder": "Company",
      "teamName": "Team name",
      "teamNamePlaceholder": "Team",
      "backgroundColour": "Background color",
      "primaryColour": "Primary color",
      "secondaryColour": "Secondary color",
      "pickColour": "Pick a color"
    },
    "frameTitle": "Branding",
    "viewModeEditor": "Settings",
    "viewModePreview": "Preview",
    "viewModeSplit": "Split",
    "previewLabel": "Share branding preview",
    "previewHint": "Approximate look on public callouts, emails, and shortlists. Not pixel-perfect.",
    "previewCalloutTitle": "Public callout",
    "previewEmailTitle": "Email header",
    "previewShortlistTitle": "Public shortlist",
    "previewSampleCompany": "Your organization",
    "previewSampleTeam": "Your team",
    "previewSampleCalloutTitle": "Open call for talent",
    "previewSampleCalloutDescription": "Applicants see your logo and colors on this page.",
    "previewSampleCta": "Apply now",
    "previewSampleEmailSubject": "Booking update",
    "previewSampleEmailBody": "Hi Alex, you have an update from {{team}}.",
    "previewSampleShortlistTitle": "Spring campaign shortlist",
    "previewSampleShortlistBadge": "Shared with client",
    "save": "Save",
    "cancel": "Cancel",
    "saveSuccess": "Public profile updated",
    "saveFailed": "Failed to update public profile",
    "loadFailed": "Couldn't load public profile settings",
    "missingTeam": "Open this page from a team to edit its public profile."
  },
  "resourceTypesAdmin": {
    "globalTitle": "Resource types",
    "globalDescription": "Manage system wide resource types that are synced across workspaces.",
    "workspaceTitle": "Resource types",
    "workspaceDescription": "Manage resource types that are visible in this workspace and manage specific workspace fields.",
    "name": "Name",
    "type": "Type",
    "workspaces": "Workspaces",
    "assignWorkspaces": "Manage workspaces",
    "searchWorkspaces": "Search workspaces…",
    "openInWorkspace": "Open {{workspace}} settings",
    "workspacesTabHint": "Resource types are not assigned to workspaces by default. Enable them where they should appear.",
    "workspacesSearchNoResults": "No workspaces found",
    "workspacesTabEmpty": "No workspaces in this organization yet",
    "workspacesLoadError": "Couldn't load workspaces",
    "newResourceType": "New resource type",
    "createTitle": "Create resource type",
    "createDescription": "Create a resource type available across the organization.",
    "fieldName": "Name",
    "fieldIcon": "Icon",
    "fieldMechanism": "Type",
    "mechanismLockedHint": "Cannot be edited once created.",
    "chooseIcon": "Choose icon",
    "active": "Active",
    "inactive": "Inactive",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "activateFieldTitle": "Activate field?",
    "activateFieldDescription": "Are you sure you want to activate this field?",
    "deactivateFieldTitle": "Deactivate field?",
    "deactivateFieldDescription": "Are you sure you want to deactivate this field? You will not lose any data.",
    "edit": "Edit",
    "archive": "Archive",
    "unarchive": "Restore",
    "archiveSuccess": "Resource type archived",
    "unarchiveSuccess": "Resource type restored",
    "enable": "Enable in workspace",
    "disable": "Disable in workspace",
    "enableSuccess": "Resource type enabled in workspace",
    "disableSuccess": "Resource type disabled in workspace",
    "disabledInWorkspaceTitle": "This resource type is disabled in {{workspace}}",
    "disabledInWorkspaceDescription": "Members of this workspace won't see resources of this type until it's enabled.",
    "disableConfirmTitle": "Disable resource types?",
    "disableConfirmDescription": "Selected resource types will no longer appear in this workspace. You will not lose any data.",
    "detailsTab": "Details",
    "detailsSaveSuccess": "Resource type saved",
    "detailsSaveFailed": "Couldn't save resource type",
    "fieldsTab": "Fields",
    "globalDetailSubtitle": "Edit this resource type for all workspaces.",
    "workspaceDetailSubtitle": "Edit workspace-specific options for this resource type. To edit more about this resource type navigate to the Global Resource Types page.",
    "viewGlobalSettings": "View global settings",
    "viewGlobalResourceTypes": "View global resource types",
    "globalFieldsTitle": "Global fields",
    "globalFieldsHint": "Fields edited and added here will be applied to all workspaces. To edit workspace specific fields head to the workspace settings.",
    "workspaceGlobalFieldsHint": "Global fields are only editable outside the workspace within the global configurations.",
    "configureGlobalFields": "Configure global fields",
    "workspaceFieldsTitle": "{{workspace}} fields",
    "workspaceFallbackName": "Workspace",
    "required": "Required",
    "locked": "Locked",
    "filterable": "Filterable",
    "requiredEnabledToast": "Field marked as required",
    "requiredDisabledToast": "Field no longer required",
    "filterableEnabledToast": "Field is now filterable",
    "filterableDisabledToast": "Field is no longer filterable",
    "fieldPropertyUpdateError": "Couldn't update field",
    "fieldType": "Type",
    "addField": "Add field",
    "addFieldAssignPrompt": "This will be added to",
    "searchFields": "Search fields…",
    "fieldsSearchNoResults": "No fields found",
    "dangerousActions": "Dangerous actions",
    "archiveSectionTitle": "Archive resource type",
    "archiveSectionDescription": "Data will be preserved but users across workspaces will no longer see this resource type",
    "unarchiveSectionTitle": "Restore resource type",
    "unarchiveSectionDescription": "Restore this resource type so it can be enabled in workspaces again.",
    "entityNameSingular": "resource type",
    "entityNamePlural": "resource types",
    "fieldEntityNameSingular": "field",
    "fieldEntityNamePlural": "fields",
    "batchArchiveSelected": "Archive selected",
    "batchUnarchiveSelected": "Restore selected",
    "batchActivateSelected": "Activate selected",
    "batchDeactivateSelected": "Deactivate selected",
    "batchActivateFieldsNone": "No fields to activate",
    "batchDeactivateFieldsNone": "Locked system fields can't be deactivated",
    "batchEnableSelected": "Enable selected",
    "batchDisableSelected": "Disable selected",
    "reorderFields": "Reorder field",
    "emptyActive": "No active resource types",
    "emptyInactive": "No inactive resource types",
    "emptyArchived": "No archived resource types",
    "emptyFields": "No fields yet",
    "emptyInactiveFields": "No inactive fields",
    "loadError": "Couldn't load this resource type",
    "localPreviewNote": "Workspace enablement and fields are saved locally in this browser until the backend supports them.",
    "assignResourceTypesAction": "Enable resource types",
    "assignResourceTypesTitle": "Enable resource types",
    "assignResourceTypesSearchPlaceholder": "Search resource types…",
    "assignResourceTypesSelectedCount": "{{count}} selected",
    "assignResourceTypesSelectPrompt": "Select resource types to enable in this workspace",
    "assignResourceTypesUnselectAll": "Unselect all",
    "assignResourceTypesEmpty": "All resource types are already enabled in this workspace",
    "assignResourceTypesNoResults": "No resource types found",
    "assignResourceTypesConfirm": "Enable ({{count}})",
    "assignResourceTypesLoadError": "Couldn't load resource types",
    "create": "Create",
    "createFailed": "Couldn't create resource type",
    "unsavedChangesBeforeUnload": "You have unsaved changes!",
    "cancel": "Cancel",
    "mechanisms": {
      "INDIVIDUAL": "Individual",
      "ORGANIZATION": "Organization",
      "LOCATION": "Location",
      "ITEM": "Item",
      "TALENT": "Talent",
      "AGENT": "Agent"
    }
  },
  "app_update": {
    "message": "A new version of the app is available.",
    "refresh": "Refresh"
  },
  "app_crash": {
    "title": "Something Went Wrong",
    "description": "The app has crashed. Please refresh and try again or contact us for help",
    "refresh": "Refresh",
    "goToDashboard": "Go to dashboard",
    "errorLogLabel": "Error details"
  },
  "server_unreachable": {
    "bootstrap": {
      "title": "Couldn't load the app",
      "description_connection": "We couldn't connect to the server. Check your connection and refresh.",
      "description_server": "The server returned an error while loading required data. Try again in a moment."
    },
    "session": {
      "title": "Couldn't load your session",
      "description_connection": "We couldn't reach the server to load your account settings. Check your connection and refresh.",
      "description_server": "Your account settings couldn't be loaded due to a server error. Try again in a moment."
    },
    "sign_in": {
      "title": "Sign-in unavailable",
      "description_connection": "We couldn't connect to verify sign-in options. Check your connection and refresh.",
      "description_server": "Sign-in is temporarily unavailable due to a server error. Try again in a moment."
    },
    "refresh": "Refresh",
    "goToDashboard": "Go to dashboard",
    "errorLogLabel": "Error details"
  },
  "not_found": {
    "title": "Sorry, we can't find what you're looking for",
    "description": "Check the link is correct or make sure you are logged in. If you are still having issues we are here to help!",
    "contactSupport": "Contact support",
    "goToDashboard": "Go to dashboard",
    "workspace": {
      "title": "Cannot find workspace",
      "description": "This workspace may have been removed, or you may have the wrong link"
    },
    "team": {
      "title": "Cannot find team",
      "description": "This team may have been removed, or you may have the wrong link"
    },
    "contact": {
      "title": "Cannot find contact",
      "description": "This contact may be archived, or you may have the wrong link"
    },
    "production": {
      "title": "Cannot find production",
      "description": "This production may be archived, or you may have the wrong link"
    },
    "callout": {
      "title": "Cannot find callout",
      "description": "This callout may be archived, or you may have the wrong link"
    },
    "callsheet": {
      "title": "Cannot find callsheet",
      "description": "This callsheet may be archived, or you may have the wrong link"
    },
    "shortlist": {
      "title": "Cannot find shortlist",
      "description": "This shortlist may be archived, or you may have the wrong link"
    }
  },
  "sandbox": {
    "badge": "Sandbox",
    "title": "You're in the sandbox",
    "subtitle": "A safe playground to try what's coming next.",
    "isolated": {
      "title": "Completely isolated",
      "description": "Nothing you do here touches your production account or its data."
    },
    "early_access": {
      "title": "Early access",
      "description": "New features land here 1–2 weeks before they go live for all your users."
    },
    "feedback": {
      "title": "Help shape what ships",
      "description": "Spotted an issue or have an idea? We'd love to hear it."
    },
    "send_feedback": "Send feedback",
    "dismiss": "Got it"
  },
  "commandBar": {
    "label": "Search or create",
    "onThisPage": "On this page"
  }
}
